import { EngagementOracle } from "@airdao/bond-periphery/core/contracts/types";
import { ContractNames, Contracts } from "@airdao/bond-periphery/core";
import { AddressLike, BigNumberish } from "ethers";

export async function SetUserTier(contracts: Contracts, contractName: ContractNames = ContractNames.EngagementOracle, user: AddressLike, tier: BigNumberish) {
  const oracle = contracts.getContractByName(contractName) as unknown as EngagementOracle;
  return await oracle.setTier(user, tier);
}

export async function SetUserTiersBatch(
  contracts: Contracts,
  contractName: ContractNames = ContractNames.EngagementOracle,
  tiersData: { user: AddressLike; tier: BigNumberish }[],
) {
  const oracle = contracts.getContractByName(
    contractName,
  ) as unknown as EngagementOracle;
  return await oracle.setTiersBatch(tiersData);
}

export async function ResetUserTiers(contracts: Contracts, contractName: ContractNames = ContractNames.EngagementOracle) {
  const oracle = contracts.getContractByName(contractName) as unknown as EngagementOracle;
  return await oracle.resetTiers();
}

export const SetterMethods = {
  SetUserTier,
  ResetUserTiers,
};

export default SetterMethods;